import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom'; // Added useNavigate
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Container, Navbar, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faHome, faShoppingCart, faBox, faUsers, faBuilding, faShippingFast, faUniversity, faFileInvoiceDollar, faWarehouse, faCalendarAlt, faCog, faPlus, faDatabase, faBoxOpen, faFilm, faMusic, faHandshake, faThLarge, faFileInvoice, faClipboardList, faMoneyBillWave, faExchangeAlt, faDollyFlatbed, faEnvelope, faTasks, faGlobe, faTags, faSync, faSignOutAlt, faTrophy, faGift, faBullhorn, faFilePdf, faStar, faThumbsUp, faHeart, faChartLine, faUserTie, faFileAlt, faHourglassHalf, faCheckCircle, faBan, faInbox, faImage, faExclamationTriangle, faUndo, faUserEdit, faBuildingColumns, faTag, faChartPie, faArrowUpRightFromSquare, faHandHoldingDollar, faCartArrowDown } from '@fortawesome/free-solid-svg-icons';
import Footer from './Footer';
import api, { getDatiAzienda } from '../api';
import BadgeCounter from '../components/BadgeCounter';
import { useAuth } from '../context/AuthContext'; // Added useAuth
import { useSidebar } from '../context/SidebarContext'; // Added useSidebar
import { PageTitleProvider, useCurrentPageTitle, useCurrentPageStats } from '../context/PageTitleContext';
import { useMediaQuery } from 'react-responsive';

const DashboardLayoutContent = ({ children }) => {
    const pageTitle = useCurrentPageTitle();
    const pageStats = useCurrentPageStats();
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false); // Desktop: collapsed vs expanded
    const { isMobileSidebarOpen, setIsMobileSidebarOpen, closeMobileSidebar, isMobile } = useSidebar(); // Use context
    const [logoUrl, setLogoUrl] = useState(''); // Nuovo stato per l'URL del logo
    const [fraseDelGiorno, setFraseDelGiorno] = useState(''); // Nuovo stato per la frase del giorno
    const { logout } = useAuth(); // NEW: Use AuthContext
    const navigate = useNavigate(); // NEW: Use useNavigate
    const location = useLocation();

    // Chiudi la sidebar mobile ad ogni cambio di route
    useEffect(() => {
        if (isMobile) {
            setIsMobileSidebarOpen(false);
        }
    }, [location.pathname]);
    
    // Stati per conteggi notifiche
    const [notificheCounts, setNotificheCounts] = useState({
        ordini: 0,
        preventivi: 0,
        valutazioni: 0,
        recensioni: 0,
        prodotti: 0,
        fornitori: 0,
        messaggi: 0,
        sistema: 0,
        totale: 0
    });
    const [promoScadute, setPromoScadute] = useState(0);
    const [erroriOfferteIbs, setErroriOfferteIbs] = useState(0);
    const [reclamiAperti, setReclamiAperti] = useState(0);
    const [fogliNuvei, setFogliNuvei] = useState(0);
    const [movimentiDaClassificare, setMovimentiDaClassificare] = useState(0);
    const [richiesteFattura, setRichiesteFattura] = useState(0);
    const [ordiniRimborsiDaValutare, setOrdiniRimborsiDaValutare] = useState(0);
    const [ordiniDestinatarioDaVerificare, setOrdiniDestinatarioDaVerificare] = useState(0);
    const intervalRef = useRef(null);

    // Banner repricing in corso: controlla sessionStorage ogni 5s
    const [repricingJobActive, setRepricingJobActive] = useState(
        () => !!sessionStorage.getItem('repricing_job_id')
    );
    useEffect(() => {
        const checkJob = () => setRepricingJobActive(!!sessionStorage.getItem('repricing_job_id'));
        const t = setInterval(checkJob, 5000);
        return () => clearInterval(t);
    }, []);

    // Funzione per fetchare conteggi notifiche
    const fetchNotificheCounts = async () => {
        try {
            const response = await api.get('/notifiche/count');
            
            setNotificheCounts(response.data || {
                ordini: 0,
                preventivi: 0,
                valutazioni: 0,
                recensioni: 0,
                prodotti: 0,
                fornitori: 0,
                messaggi: 0,
                sistema: 0,
                totale: 0
            });
        } catch (error) {
            console.error('Errore nel caricamento conteggi notifiche sidebar:', error);
        }
    };

    // Genera notifiche e fetch conteggi al mount e ogni 30 secondi
    useEffect(() => {
        const generateAndFetchNotifiche = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) return;

                // Genera notifiche automatiche
                await api.post('/notifiche/generate');
                
                // Poi carica conteggi aggiornati
                await fetchNotificheCounts();

                // Promozioni ancora attive ma con data_fine passata: vanno rinnovate o disattivate
                try {
                    const promo = await api.get('/promozioni/?skip=0&limit=200');
                    const ora = new Date();
                    setPromoScadute((promo.data || []).filter((p) => p.is_active && new Date(p.data_fine) < ora).length);
                } catch (e) {
                    console.error('Errore nel conteggio promozioni scadute:', e);
                }

                // Ordini da evadere di clienti con rimborsi precedenti, in attesa di decisione
                try {
                    const rimborsi = await api.get('/ordini/avvisi-rimborsi/count');
                    setOrdiniRimborsiDaValutare(rimborsi.data?.count || 0);
                } catch (e) {
                    console.error('Errore nel conteggio ordini da clienti con rimborsi:', e);
                }

                // Ordini marketplace spediti a un nome diverso dall'acquirente, in attesa di scelta
                try {
                    const dest = await api.get('/ordini/avvisi-destinatario/count');
                    setOrdiniDestinatarioDaVerificare(dest.data?.count || 0);
                } catch (e) {
                    console.error('Errore nel conteggio ordini con destinatario da verificare:', e);
                }

                // Offerte rifiutate da IBS/Mirakl (es. barcode non presente nel catalogo)
                try {
                    const errori = await api.get('/mirakl/errori-offerte/count');
                    setErroriOfferteIbs(errori.data?.count || 0);
                } catch (e) {
                    console.error('Errore nel conteggio errori offerte IBS:', e);
                }

                // Reclami aperti dai clienti su Mirakl
                try {
                    const reclami = await api.get('/mirakl/reclami/count');
                    setReclamiAperti(reclami.data?.count || 0);
                } catch (e) {
                    console.error('Errore nel conteggio reclami IBS:', e);
                }

                // Fogli di liquidazione Nuvei da verificare o mancanti (bonifici IBS su myPOS)
                try {
                    const nuvei = await api.get('/mirakl/payments/nuvei-avvisi/count');
                    setFogliNuvei(nuvei.data?.count || 0);
                } catch (e) {
                    console.error('Errore nel conteggio fogli Nuvei:', e);
                }

                // Movimenti di carte e conti (azienda/personale) ancora da classificare
                try {
                    const conti = await api.get('/conti/movimenti/count');
                    setMovimentiDaClassificare(conti.data?.da_classificare || 0);
                } catch (e) {
                    console.error('Errore nel conteggio movimenti da classificare:', e);
                }

                // Richieste di fattura dai clienti IBS ancora senza risposta
                try {
                    const rf = await api.get('/mirakl/richieste-fattura/count');
                    setRichiesteFattura(rf.data?.count || 0);
                } catch (e) {
                    console.error('Errore nel conteggio richieste fattura:', e);
                }
            } catch (error) {
                if (error.response?.status === 401) {
                    clearInterval(intervalRef.current);
                    logout();
                    return;
                }
                console.error('Errore nella generazione/fetch notifiche:', error);
            }
        };

        // Prima chiamata
        generateAndFetchNotifiche();

        // Polling ogni 30 secondi
        intervalRef.current = setInterval(generateAndFetchNotifiche, 30000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const fetchDatiAzienda = async () => { // Rinominato per chiarezza
            try {
                const response = await getDatiAzienda();

                if (response) {
                    if (response.logo_url) {
                        setLogoUrl(`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}${response.logo_url}`);
                    }
                    if (response.frase_delGiorno) {
                        setFraseDelGiorno(response.frase_delGiorno);
                    }
                }
            } catch (error) {
                console.error('Errore durante il recupero dei dati azienda:', error);
            }
        };
        fetchDatiAzienda(); // Chiamata alla funzione aggiornata
    }, []); // Esegui solo al mount del componente

    useEffect(() => {
        const fetchDatiAzienda = async () => { // Rinominato per chiarezza
            try {
                const response = await getDatiAzienda();

                if (response) {
                    if (response.logo_url) {
                        setLogoUrl(`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}${response.logo_url}`);
                    }
                    if (response.frase_delGiorno) {
                        setFraseDelGiorno(response.frase_delGiorno);
                    }
                }
            } catch (error) {
                console.error('Errore durante il recupero dei dati azienda:', error);
            }
        };
        fetchDatiAzienda(); // Chiamata alla funzione aggiornata
    }, []); // Esegui solo al mount del componente

    const handleLogout = () => { // NEW: Logout handler
        logout();
        navigate('/login');
    };

    const handleMenuToggle = () => {
        if (isMobile) {
            setIsMobileSidebarOpen(!isMobileSidebarOpen);
        } else {
            setIsSidebarCollapsed(!isSidebarCollapsed);
        }
    };

    const handleMenuItemClick = () => {
        closeMobileSidebar(); // Use context function
    };

    // Avvisi rapidi in header: solo desktop, solo quelli con qualcosa da fare.
    // "ibs" e' l'ordine marketplace in stato "Da Accettare" (vedi generate_ibs_notifica),
    // "preventivi" sono le richieste di preventivo, oggi tutte originate dal sito
    // riversamenti — da qui l'etichetta e il link diretto alla loro inbox dedicata.
    const avvisiHeader = [
        { key: 'da_lavorare', label: 'Ordini da lavorare', count: notificheCounts.ordini, priority: 'importante', icon: faHourglassHalf, to: '/ordini?quick=in_lavorazione' },
        { key: 'da_accettare', label: 'Ordini da accettare', count: notificheCounts.ibs, priority: 'urgente', icon: faExchangeAlt, to: '/ordini?quick=da_accettare' },
        { key: 'rimborsi', label: 'Clienti con rimborsi', count: ordiniRimborsiDaValutare, priority: 'urgente', icon: faUndo, to: '/ordini?quick=rimborsi' },
        { key: 'destinatario', label: 'Destinatari da verificare', count: ordiniDestinatarioDaVerificare, priority: 'urgente', icon: faUserEdit, to: '/ordini?quick=destinatario' },
        { key: 'messaggi', label: 'Messaggi IBS', count: notificheCounts.messaggi, priority: 'importante', icon: faEnvelope, to: '/integrazioni/ibs/messaggi' },
        { key: 'richieste_fattura', label: 'Richieste fattura', count: richiesteFattura, priority: 'urgente', icon: faFileInvoiceDollar, to: '/integrazioni/ibs/messaggi' },
        { key: 'reclami', label: 'Reclami IBS', count: reclamiAperti, priority: 'urgente', icon: faExclamationTriangle, to: '/integrazioni/ibs/reclami' },
        { key: 'riversamenti', label: 'Riversamenti', count: notificheCounts.preventivi, priority: 'importante', icon: faFilm, to: '/preventivi/riversamenti' },
        { key: 'fogli_nuvei', label: 'Fogli Nuvei da verificare', count: fogliNuvei, priority: 'urgente', icon: faMoneyBillWave, to: '/integrazioni/ibs/pagamenti' },
        { key: 'errori_offerte', label: 'Errori offerte IBS', count: erroriOfferteIbs, priority: 'urgente', icon: faExclamationTriangle, to: '/integrazioni/ibs/errori-offerte' },
        { key: 'promo_scadute', label: 'Promo scadute', count: promoScadute, priority: 'importante', icon: faTags, to: '/promozioni' },
    ].filter((a) => a.count > 0);

    return (
        <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
            {/* Mobile backdrop */}
            {isMobile && isMobileSidebarOpen && (
                <div 
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1049
                    }}
                    onClick={() => setIsMobileSidebarOpen(false)}
                />
            )}
            <Sidebar 
                breakPoint="lg" 
                width="290px"
                backgroundColor="#fff" 
                collapsed={isMobile ? false : isSidebarCollapsed}
                toggled={isMobile ? isMobileSidebarOpen : false}
                onBackdropClick={() => setIsMobileSidebarOpen(false)}
                rootStyles={{
                    color: '#333',
                    borderRight: '1px solid #ddd',
                    position: isMobile ? 'fixed' : 'relative',
                    zIndex: 1050,
                    height: isMobile ? '100vh' : 'auto'
                }}
            >
                <Menu menuItemStyles={{
                    label: () => ({
                        whiteSpace: 'normal',
                        overflow: 'visible',
                        textOverflow: 'clip',
                        lineHeight: 1.25,
                    }),
                    button: ({ level, active }) => ({
                        height: 'auto',
                        minHeight: 44,
                        paddingTop: 6,
                        paddingBottom: 6,
                        outline: 'none',
                        backgroundColor: active ? '#e0f2fe' : 'transparent',
                        color: active ? '#0d6efd' : '#333',
                        '&:hover': {
                            backgroundColor: '#f0f2f5',
                            color: '#0d6efd',
                        },
                    }),
                    subMenuContent: ({ level }) => ({
                        backgroundColor: '#f8f9fa',
                    }),
                }}>
                    <MenuItem 
                        component={<Link to="/" />} 
                        icon={<FontAwesomeIcon icon={faHome} />}
                        onClick={handleMenuItemClick}
                    >
                        Dashboard
                    </MenuItem>

                    <SubMenu label="Ordini" icon={<FontAwesomeIcon icon={faShoppingCart} />}>
                        <MenuItem
                            component={<Link to="/ordini" />}
                            icon={<FontAwesomeIcon icon={faShoppingCart} />}
                            onClick={handleMenuItemClick}
                        >
                            Tutti gli ordini
                        </MenuItem>
                        <MenuItem
                            component={<Link to="/ordini?quick=in_lavorazione" />}
                            icon={<FontAwesomeIcon icon={faHourglassHalf} />}
                            onClick={handleMenuItemClick}
                        >
                            In lavorazione
                            {notificheCounts.ordini > 0 && (
                                <BadgeCounter
                                    count={notificheCounts.ordini}
                                    priority="importante"
                                    size="sm"
                                />
                            )}
                        </MenuItem>
                        <MenuItem
                            component={<Link to="/ordini/abbandoni" />}
                            icon={<FontAwesomeIcon icon={faCartArrowDown} />}
                            onClick={handleMenuItemClick}
                        >
                            Abbandoni
                        </MenuItem>
                        <MenuItem
                            component={<Link to="/ordini?quick=senza_rapporto" />}
                            icon={<FontAwesomeIcon icon={faExclamationTriangle} />}
                            onClick={handleMenuItemClick}
                        >
                            Senza metodo di pagamento
                        </MenuItem>
                        <MenuItem
                            component={<Link to="/ordini?quick=concluso" />}
                            icon={<FontAwesomeIcon icon={faCheckCircle} />}
                            onClick={handleMenuItemClick}
                        >
                            Conclusi
                        </MenuItem>
                        <MenuItem
                            component={<Link to="/ordini?quick=annullati" />}
                            icon={<FontAwesomeIcon icon={faBan} />}
                            onClick={handleMenuItemClick}
                        >
                            Annullati e rimborsati
                        </MenuItem>
                    </SubMenu>

                    <SubMenu label="Conti e movimenti" icon={<FontAwesomeIcon icon={faBuildingColumns} />} suffix={<BadgeCounter count={movimentiDaClassificare} priority="importante" size="sm" />}>
                        <MenuItem component={<Link to="/conti/movimenti" />} icon={<FontAwesomeIcon icon={faExchangeAlt} />} suffix={<BadgeCounter count={movimentiDaClassificare} priority="importante" size="sm" />}>Movimenti</MenuItem>
                        <MenuItem component={<Link to="/conti/rapporti" />} icon={<FontAwesomeIcon icon={faBuildingColumns} />}>Rapporti bancari</MenuItem>
                        <MenuItem component={<Link to="/conti/piano" />} icon={<FontAwesomeIcon icon={faTag} />}>Piano dei conti</MenuItem>
                        <MenuItem component={<Link to="/conti/finanziamenti" />} icon={<FontAwesomeIcon icon={faHandHoldingDollar} />}>Finanziamenti</MenuItem>
                        <MenuItem component={<Link to="/conti/bilancio" />} icon={<FontAwesomeIcon icon={faChartPie} />}>Bilancio</MenuItem>
                        <MenuItem component={<Link to="/accounting/config" />} icon={<FontAwesomeIcon icon={faCog} />}>Conti automatici</MenuItem>
                        <MenuItem component={<a href="https://firefly.modenacinema.it" target="_blank" rel="noopener noreferrer" />} icon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}>Firefly azienda</MenuItem>
                        <MenuItem component={<a href="https://firefly.personale.modenacinema.it" target="_blank" rel="noopener noreferrer" />} icon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}>Firefly personale</MenuItem>
                    </SubMenu>

                    <SubMenu label="Catalogo" icon={<FontAwesomeIcon icon={faBox} />}>
                        <MenuItem component={<Link to="/film" />} icon={<FontAwesomeIcon icon={faFilm} />} onClick={handleMenuItemClick}>Film</MenuItem>
                        <MenuItem component={<Link to="/musica" />} icon={<FontAwesomeIcon icon={faMusic} />} onClick={handleMenuItemClick}>Musica</MenuItem>
                        <MenuItem component={<Link to="/collectibles" />} icon={<FontAwesomeIcon icon={faBoxOpen} />}>Collezionabili</MenuItem>
                    </SubMenu>

                    <SubMenu label="Anagrafiche" icon={<FontAwesomeIcon icon={faUsers} />}>
                        <MenuItem component={<Link to="/clienti" />} icon={<FontAwesomeIcon icon={faUsers} />}>Clienti</MenuItem>
                        <MenuItem component={<Link to="/fornitori" />} icon={<FontAwesomeIcon icon={faBuilding} />}>Fornitori</MenuItem>
                        <MenuItem component={<Link to="/corrieri" />} icon={<FontAwesomeIcon icon={faShippingFast} />}>Corrieri</MenuItem>
                        <MenuItem component={<Link to="/banche" />} icon={<FontAwesomeIcon icon={faUniversity} />}>Banche</MenuItem>
                        <MenuItem component={<Link to="/admin/users" />} icon={<FontAwesomeIcon icon={faUsers} />}>Utenti</MenuItem>
                    </SubMenu>

                    <SubMenu label="Siti web" icon={<FontAwesomeIcon icon={faGlobe} />} suffix={<>{((notificheCounts.preventivi || 0) + (notificheCounts.recensioni || 0) + (notificheCounts.valutazioni || 0)) > 0 && <BadgeCounter count={(notificheCounts.preventivi || 0) + (notificheCounts.recensioni || 0) + (notificheCounts.valutazioni || 0)} priority="importante" size="sm" />}</>}>
                        <SubMenu label="ModenaCinema.it" icon={<FontAwesomeIcon icon={faShoppingCart} />} suffix={<>{((notificheCounts.recensioni || 0) + (notificheCounts.valutazioni || 0)) > 0 && <BadgeCounter count={(notificheCounts.recensioni || 0) + (notificheCounts.valutazioni || 0)} priority="importante" size="sm" />}</>}>
                            <MenuItem component={<Link to="/admin/layout/homepage" />} icon={<FontAwesomeIcon icon={faThLarge} />}>Layout Homepage</MenuItem>
                            <MenuItem component={<Link to="/gestione-about" />} icon={<FontAwesomeIcon icon={faThLarge} />}>Chi siamo</MenuItem>
                            <MenuItem component={<Link to="/promozioni" />} icon={<FontAwesomeIcon icon={faTags} />}>Promozioni</MenuItem>
                            <MenuItem component={<Link to="/codici-sconto" />} icon={<FontAwesomeIcon icon={faTags} />}>Codici Sconto</MenuItem>
                            <MenuItem 
                                component={<Link to="/recensioni/gestione" />} 
                                icon={<FontAwesomeIcon icon={faStar} />}
                            >
                                Recensioni
                                {notificheCounts.recensioni > 0 && (
                                    <BadgeCounter 
                                        count={notificheCounts.recensioni} 
                                        priority="info" 
                                        size="sm" 
                                    />
                                )}
                            </MenuItem>
                            <MenuItem 
                                component={<Link to="/valutazioni-servizio/gestione" />} 
                                icon={<FontAwesomeIcon icon={faThumbsUp} />}
                            >
                                Valutazioni Servizio
                                {notificheCounts.valutazioni > 0 && (
                                    <BadgeCounter 
                                        count={notificheCounts.valutazioni} 
                                        priority="info" 
                                        size="sm" 
                                    />
                                )}
                            </MenuItem>
                            <MenuItem 
                                component={<Link to="/wishlist/gestione" />} 
                                icon={<FontAwesomeIcon icon={faHeart} className="text-danger" />}
                            >
                                Wishlist Clienti
                            </MenuItem>
                            <SubMenu label="Fedeltà" icon={<FontAwesomeIcon icon={faTrophy} />}>
                                <MenuItem component={<Link to="/punti-fedelta/config" />} icon={<FontAwesomeIcon icon={faCog} />}>Configurazione</MenuItem>
                                <MenuItem component={<Link to="/punti-fedelta/gestione" />} icon={<FontAwesomeIcon icon={faGift} />}>Gestione Punti</MenuItem>
                            </SubMenu>
                            <MenuItem component={<Link to="/email-schedulate" />} icon={<FontAwesomeIcon icon={faCalendarAlt} />}>Email Schedulate</MenuItem>
                            <MenuItem component={<Link to="/impostazioni/spedizione-sito" />} icon={<FontAwesomeIcon icon={faShippingFast} />}>Spedizione sito</MenuItem>
                        </SubMenu>
                        <SubMenu label="ModenaRiversamenti.it" icon={<FontAwesomeIcon icon={faFilm} />} suffix={<>{(notificheCounts.preventivi || 0) > 0 && <BadgeCounter count={notificheCounts.preventivi || 0} priority="importante" size="sm" />}</>}>
                            <MenuItem
                                component={<Link to="/preventivi/riversamenti" />}
                                icon={<FontAwesomeIcon icon={faInbox} />}
                                onClick={handleMenuItemClick}
                            >
                                Richieste
                                {notificheCounts.preventivi > 0 && (
                                    <BadgeCounter
                                        count={notificheCounts.preventivi}
                                        priority="importante"
                                        size="sm"
                                    />
                                )}
                            </MenuItem>
                            <MenuItem
                                component={<Link to="/preventivi" />}
                                icon={<FontAwesomeIcon icon={faHandshake} />}
                                onClick={handleMenuItemClick}
                            >
                                Tutti i preventivi
                            </MenuItem>
                            <MenuItem
                                component={<Link to="/servizi" />}
                                icon={<FontAwesomeIcon icon={faTags} />}
                                onClick={handleMenuItemClick}
                            >
                                Listino servizi
                            </MenuItem>
                            <MenuItem
                                component={<Link to="/riversamenti/contenuti" />}
                                icon={<FontAwesomeIcon icon={faThLarge} />}
                                onClick={handleMenuItemClick}
                            >
                                Contenuti del sito
                            </MenuItem>
                            <MenuItem
                                component={<Link to="/impostazioni/dati-azienda?tab=riversamenti" />}
                                icon={<FontAwesomeIcon icon={faImage} />}
                                onClick={handleMenuItemClick}
                            >
                                Logo e dati azienda
                            </MenuItem>
                        </SubMenu>
                    </SubMenu>

                    <SubMenu label="IBS / Mirakl" icon={<FontAwesomeIcon icon={faExchangeAlt} />}>
                        <MenuItem
                            component={<Link to="/integrazioni/ibs/messaggi" />}
                            icon={<FontAwesomeIcon icon={faEnvelope} />}
                        >
                            Messaggi
                            {notificheCounts.messaggi > 0 && (
                                <BadgeCounter
                                    count={notificheCounts.messaggi}
                                    priority="importante"
                                    size="sm"
                                />
                            )}
                        </MenuItem>
                        <MenuItem
                            component={<Link to="/integrazioni/ibs/reclami" />}
                            icon={<FontAwesomeIcon icon={faExclamationTriangle} />}
                        >
                            Reclami
                            {reclamiAperti > 0 && (
                                <BadgeCounter count={reclamiAperti} priority="urgente" size="sm" />
                            )}
                        </MenuItem>
                        <MenuItem component={<Link to="/integrazioni/ibs/pagamenti" />} icon={<FontAwesomeIcon icon={faMoneyBillWave} />}>Pagamenti</MenuItem>
                        <MenuItem component={<Link to="/integrazioni/ibs/notifiche-consegna" />} icon={<FontAwesomeIcon icon={faEnvelope} />}>Notifiche consegna</MenuItem>
                        <SubMenu label="Prezzi" icon={<FontAwesomeIcon icon={faTags} />}>
                            <MenuItem component={<Link to="/integrazioni/ibs/ricarichi" />} icon={<FontAwesomeIcon icon={faTags} />}>Ricarichi IBS</MenuItem>
                            <MenuItem component={<Link to="/integrazioni/ibs/repricing" />} icon={<FontAwesomeIcon icon={faSync} />}>Repricing</MenuItem>
                            <MenuItem component={<Link to="/integrazioni/ibs/repricing-dashboard" />} icon={<FontAwesomeIcon icon={faChartLine} />}>Storico variazioni</MenuItem>
                        </SubMenu>
                        <MenuItem component={<Link to="/integrazioni/ibs/prodotti" />} icon={<FontAwesomeIcon icon={faBox} />}>Prodotti</MenuItem>
                    </SubMenu>

                    <SubMenu label="Attività" icon={<FontAwesomeIcon icon={faTasks} />}>
                        <MenuItem component={<Link to="/calendario" />} icon={<FontAwesomeIcon icon={faCalendarAlt} />} onClick={handleMenuItemClick}>Calendario</MenuItem>
                        <MenuItem component={<Link to="/attivita" />} icon={<FontAwesomeIcon icon={faTasks} />} onClick={handleMenuItemClick}>Attività</MenuItem>
                    </SubMenu>

                    <SubMenu label="Marketing" icon={<FontAwesomeIcon icon={faBullhorn} />}>
                        <MenuItem component={<Link to="/cataloghi" />} icon={<FontAwesomeIcon icon={faFilePdf} />}>Cataloghi PDF</MenuItem>
                        <MenuItem component={<Link to="/copertine-dvd" />} icon={<FontAwesomeIcon icon={faFilm} />}>Copertine DVD</MenuItem>
                        <MenuItem component={<Link to="/email-templates" />} icon={<FontAwesomeIcon icon={faEnvelope} />}>Template Email</MenuItem>
                    </SubMenu>

                    <SubMenu label="Contabilità" icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}>
                        <MenuItem component={<Link to="/contabilita/prima-nota" />} icon={<FontAwesomeIcon icon={faUserTie} />}>Prima Nota</MenuItem>
                        <MenuItem component={<Link to="/contabilita/dashboard" />} icon={<FontAwesomeIcon icon={faThLarge} />}>Dashboard Contabile</MenuItem>
                        <SubMenu label="Vendite" icon={<FontAwesomeIcon icon={faShoppingCart} />}>
                            <MenuItem component={<Link to="/ordini-da-gestire" />} icon={<FontAwesomeIcon icon={faClipboardList} />}>Ordini da fatturare</MenuItem>
                            <MenuItem component={<Link to="/fatture-emesse" />} icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}>Fatture emesse</MenuItem>
                            <MenuItem component={<Link to="/ricevute" />} icon={<FontAwesomeIcon icon={faFileInvoice} />}>Ricevute</MenuItem>
                            <MenuItem component={<Link to="/registro-corrispettivi" />} icon={<FontAwesomeIcon icon={faClipboardList} />}>Registro corrispettivi</MenuItem>
                        </SubMenu>
                        <SubMenu label="Acquisti" icon={<FontAwesomeIcon icon={faFileInvoice} />}>
                            <MenuItem component={<Link to="/fatture-passive" />} icon={<FontAwesomeIcon icon={faFileInvoice} />}>Fatture passive</MenuItem>
                            <MenuItem component={<Link to="/contabilita/beni-ammortizzabili" />} icon={<FontAwesomeIcon icon={faBoxOpen} />}>Beni ammortizzabili</MenuItem>
                        </SubMenu>
                        <SubMenu label="Fisco" icon={<FontAwesomeIcon icon={faCalendarAlt} />}>
                            <MenuItem component={<Link to="/contabilita/liquidazione-iva" />} icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}>Liquidazione IVA</MenuItem>
                            <MenuItem component={<Link to="/contabilita/scadenzario" />} icon={<FontAwesomeIcon icon={faCalendarAlt} />}>Scadenzario fiscale</MenuItem>
                            <MenuItem component={<Link to="/contabilita/report-annuale" />} icon={<FontAwesomeIcon icon={faFileAlt} />}>Report Unico SP</MenuItem>
                        </SubMenu>
                    </SubMenu>

                    <SubMenu label="Magazzino" icon={<FontAwesomeIcon icon={faWarehouse} />}>
                        <MenuItem component={<Link to="/movimenti-magazzino" />} icon={<FontAwesomeIcon icon={faExchangeAlt} />}>Movimenti Magazzino</MenuItem>
                        <MenuItem component={<Link to="/magazzino/carico" />} icon={<FontAwesomeIcon icon={faDollyFlatbed} />}>Carico Magazzino</MenuItem>
                        <MenuItem component={<Link to="/magazzino/inventario" />} icon={<FontAwesomeIcon icon={faWarehouse} />}>Inventario Fisico</MenuItem>
                        <MenuItem component={<Link to="/magazzino/custodie" />} icon={<FontAwesomeIcon icon={faBoxOpen} />}>Custodie prelevate</MenuItem>
                    </SubMenu>

                    <SubMenu label="Impostazioni" icon={<FontAwesomeIcon icon={faCog} />}>
                        <MenuItem component={<Link to="/impostazioni/dati-azienda" />} icon={<FontAwesomeIcon icon={faBuilding} />}>Dati Azienda</MenuItem>
                        <MenuItem component={<Link to="/impostazioni/backup-dati" />} icon={<FontAwesomeIcon icon={faDatabase} />}>Backup DB</MenuItem>
                        <MenuItem component={<Link to="/layouts" />} icon={<FontAwesomeIcon icon={faThLarge} />}>Layout</MenuItem>
                        <MenuItem component={<Link to="/amministrazione" />} icon={<FontAwesomeIcon icon={faCog} />}>Manutenzione</MenuItem>
                        <MenuItem component={<Link to="/audit-logs" />} icon={<FontAwesomeIcon icon={faClipboardList} />}>Log di Audit</MenuItem>
                        <MenuItem component={<Link to="/impostazioni/titoli-evento-standard" />} icon={<FontAwesomeIcon icon={faClipboardList} />}>Titoli Evento Standard</MenuItem>
                    </SubMenu>

                    <MenuItem onClick={handleLogout} icon={<FontAwesomeIcon icon={faSignOutAlt} />}>Logout</MenuItem>
                </Menu>
            </Sidebar>
            <main style={{ 
                flexGrow: 1, 
                display: 'flex', 
                flexDirection: 'column', 
                overflowY: 'auto',
                marginLeft: isMobile ? 0 : 'auto',
                width: isMobile ? '100%' : 'auto'
            }}>
                <Navbar bg="light" variant="light" className="px-3 py-2 border-bottom" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div className="d-flex align-items-center" style={{ minWidth: 0, overflow: 'hidden' }}>
                        <Button variant="outline-secondary" onClick={handleMenuToggle} className="me-2 flex-shrink-0">
                            <FontAwesomeIcon icon={faBars} />
                        </Button>
                        {pageTitle && (
                            <span
                                className="fw-bold text-dark text-truncate"
                                style={{ fontSize: isMobile ? '0.95rem' : '1.15rem' }}
                            >
                                {pageTitle}
                            </span>
                        )}
                        {pageStats.length > 0 && !isMobile && (
                            <span className="ms-3 d-flex align-items-center flex-shrink-0" style={{ gap: '0.75rem' }}>
                                {pageStats.map(stat => (
                                    <span
                                        key={stat.label}
                                        className={`badge text-nowrap bg-${stat.color || 'secondary'} ${['warning', 'info'].includes(stat.color) ? 'text-dark' : 'text-white'}`}
                                        style={{ fontSize: '0.8rem', fontWeight: 500 }}
                                    >
                                        {stat.label} <strong>{stat.value}</strong>
                                    </span>
                                ))}
                            </span>
                        )}
                        {fraseDelGiorno && !isMobile && (
                            <span className="ms-3 text-muted small text-truncate">
                                {fraseDelGiorno}
                            </span>
                        )}
                    </div>
                    {!isMobile && avvisiHeader.length > 0 && (
                        <div className="d-flex align-items-center flex-shrink-0" style={{ gap: '0.5rem' }}>
                            {avvisiHeader.map((a) => (
                                <Link
                                    key={a.key}
                                    to={a.to}
                                    className="d-flex align-items-center text-decoration-none text-dark small px-2 py-1 rounded border bg-white"
                                >
                                    <FontAwesomeIcon icon={a.icon} className="me-2 text-muted" />
                                    {a.label}
                                    <BadgeCounter count={a.count} priority={a.priority} size="sm" />
                                </Link>
                            ))}
                        </div>
                    )}
                    <div className="d-flex align-items-center flex-shrink-0">
                        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center m-0 p-0 me-3">
                            {!isMobile && (
                                <span className="text-dark bttf-font me-2 fs-5">MOVIE MANAGER &gt;</span>
                            )}
                            {logoUrl ? (
                                <img src={logoUrl} alt="Logo Azienda" style={{ height: isMobile ? '26px' : '45px', width: 'auto', maxHeight: isMobile ? '26px' : '45px' }} />
                            ) : (
                                <span className="text-muted small">No Logo</span>
                            )}
                        </Navbar.Brand>
                    </div>
                </Navbar>
                <Container fluid className="py-3" style={{ flexGrow: 1, backgroundColor: '#f8f9fa' }}>
                    {notificheCounts.messaggi > 0 && (
                        <Alert
                            variant="warning"
                            className="mb-3 py-2 px-3 d-flex align-items-center justify-content-between"
                            style={{ fontSize: '0.88rem', borderRadius: 6 }}
                        >
                            <span>
                                <strong>
                                    ✉️ {notificheCounts.messaggi}{' '}
                                    {notificheCounts.messaggi === 1 ? 'messaggio' : 'messaggi'} IBS da rispondere
                                </strong>{' '}
                                — <Link to="/integrazioni/ibs/messaggi">vai ai messaggi</Link>
                            </span>
                        </Alert>
                    )}
                    {repricingJobActive && (
                        <Alert
                            variant="info"
                            className="mb-3 py-2 px-3 d-flex align-items-center justify-content-between"
                            style={{ fontSize: '0.88rem', borderRadius: 6 }}
                        >
                            <span>
                                <strong>⏳ Repricing in corso</strong> — il job sta girando in background. Puoi lavorare normalmente; torna su{' '}
                                <Link to="/integrazioni/ibs/repricing">Repricing IBS</Link>{' '}
                                per vedere lo stato.
                            </span>
                        </Alert>
                    )}
                    {children}
                </Container>
                <Footer />
            </main>
        </div>
    );
};

const DashboardLayout = ({ children }) => (
    <PageTitleProvider>
        <DashboardLayoutContent>{children}</DashboardLayoutContent>
    </PageTitleProvider>
);

export default DashboardLayout;
